import React from 'react';
import { MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBCol, MDBRow } from 'mdbreact';
import Grid from '@material-ui/core/Grid';

export class Dashboard extends React.Component {
    render() {
        return (
            <>
                <h4><b>Dashboard</b></h4>
                <MDBRow style={{marginTop:'2%'}}>
                    <MDBCol size="12" lg="3">
                        <MDBCard >
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
                <h6 className='mt-3'><b>Stats</b></h6>
                <MDBRow>
                    <MDBCol size="12" lg="4">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardTitle>Nationality</MDBCardTitle>
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="4">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardTitle>Country of Residence</MDBCardTitle>
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="4">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardTitle>Travelling to</MDBCardTitle>
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
                {/* <MDBCarousel activeItem={1} length={3} slide={true} showControls={true} showIndicators={true} multiItem>
                <MDBCarouselInner>
                <Grid container spacing={3}>
                <MDBCarouselItem itemId="1">
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="2">
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="3">
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    <Grid item xs={3}>
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                                <MDBCardTitle>Country of Residence</MDBCardTitle>
                                <MDBCardText>
                                    Some quick example text to build on the card title and make
                                    up the bulk of the card&apos;s content.
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </Grid>
                    </MDBCarouselItem>
                </Grid>
                </MDBCarouselInner>
                </MDBCarousel> */}
            </>
        )
    }
}

export default Dashboard;
